import { getRoutes } from '@ui-framework/index';
import ServiceSiteEdit from './pages/edit/index';
import ServiceSiteCreate from './pages/create/index';
import ServiceSiteList from './pages/list/index';
import schema from './schemas/routes.json';
import ErrorPage, { ERROR_PAGE_TYPE } from '../ErrorPage';

import ServiceSiteFormStore from './store/index';

const Pages = ProtectedRoute => ({
  ServiceSiteEdit: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceSiteEdit}
    />
  ),
  ServiceSiteCreate: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceSiteCreate}
    />
  ),
  ServiceSiteList: (
    <ProtectedRoute
      ErrorPage={ErrorPage}
      ERROR_PAGE_TYPE={ERROR_PAGE_TYPE}
      Component={ServiceSiteList}
    />
  ),
});

const routes = ({ ProtectedRoute, BubbleRouteError }) =>
  getRoutes({
    schema,
    ProtectedRoute,
    BubbleRouteError,
    Pages: Pages(ProtectedRoute),
  });

const stores = rootStore => [
  { servicesiteFormStore: new ServiceSiteFormStore(rootStore) },
];

export { ServiceSiteEdit, ServiceSiteCreate, ServiceSiteList, routes, stores };
